exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".practice-team--188FVvUgZ6KXs_T7FxXUfY {\n  margin-right: auto;\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"addParticipantButton": "practice-team--188FVvUgZ6KXs_T7FxXUfY",
	"addParticipantButton": "practice-team--188FVvUgZ6KXs_T7FxXUfY"
};